module.exports = __webpack_public_path__ + "img/oneBlue.12fccddd.jpg";